import { render, staticRenderFns } from "./FAQAccordion.vue?vue&type=template&id=112128ac&scoped=true&"
import script from "./FAQAccordion.vue?vue&type=script&lang=js&"
export * from "./FAQAccordion.vue?vue&type=script&lang=js&"
import style0 from "./FAQAccordion.vue?vue&type=style&index=0&id=112128ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112128ac",
  null
  
)

export default component.exports